import { render, staticRenderFns } from "./Carousel3dCoverflowEffect.vue?vue&type=template&id=754f7f9b&scoped=true"
import script from "./Carousel3dCoverflowEffect.vue?vue&type=script&lang=js"
export * from "./Carousel3dCoverflowEffect.vue?vue&type=script&lang=js"
import style0 from "./Carousel3dCoverflowEffect.vue?vue&type=style&index=0&id=754f7f9b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754f7f9b",
  null
  
)

export default component.exports